import { render, staticRenderFns } from "./Typography.vue?vue&type=template&id=4dc6485c&scoped=true&"
import script from "./Typography.vue?vue&type=script&lang=js&"
export * from "./Typography.vue?vue&type=script&lang=js&"
import style0 from "@complispace/cs-apex-definitions/dist/css/typography.css?vue&type=style&index=0&id=4dc6485c&prod&scoped=true&module=true&lang=css&"
import style1 from "./Typography.vue?vue&type=style&index=1&id=4dc6485c&prod&scoped=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "4dc6485c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VCard,VCardTitle,VChip})
